import React from "react";
import Svg from "./Svg";
import srplsLogo from "../../img/srpls.svg";

const Header = ({ collection, title }) => (
  <div id="headerSrpls">
    <div className="collection">{collection}</div>
    <div className="season">{title}</div>
    <div className="logo">
      <Svg svg={srplsLogo} />
    </div>
  </div>
);

export default Header;
